import PredictiveSearchBar from '../predictive-search-bar/predictive-search-bar.js';
class HamburgerElement extends HTMLElement {
  connectedCallback() {
    this.initEvents();
    this.initVariables();
  }

  initVariables() {
    this.megaMenuContainer = document.querySelector(
      '[data-mega-menu-container]'
    );
  }

  initEvents() {
    this.addEventListener('click', () => {
      this.classList.toggle('active');
      this.addActiveClassToMenuContainer();

      document.querySelector('body').classList.toggle('overflow-hidden');

      // For all mega menus, toggle the active class
      const megaMenus = document.querySelectorAll('[data-mega-menu]');
      const menuLinks = document.querySelectorAll('[data-menu-link]');
      for (const menu of megaMenus) {
        menu.classList.toggle('active');
      }

      // For all menu links, toggle the active class
      for (const link of menuLinks) {
        link.classList.toggle('active');
      }

      // Close the predictive search bar when opening the mega menu
      PredictiveSearchBar.closeSearchBar();
    });
  }

  /**
   * Add the active class to the menu container
   * @returns {void}
   */
  addActiveClassToMenuContainer() {
    this.megaMenuContainer.classList.toggle('active');
  }
}

customElements.get('hamburger-element') ||
  customElements.define('hamburger-element', HamburgerElement);
